import { render, staticRenderFns } from "./VendorsListing.vue?vue&type=template&id=0c7ae2d4&"
import script from "./VendorsListing.vue?vue&type=script&lang=js&"
export * from "./VendorsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports